import styled from 'styled-components';

export const MiniCartWrapper = styled.div`
  text-align: center;
  width: 100%;
`;

export const SignInPromptWrapper = styled.div`
  .fwa-signin-overlay {
    position: absolute;
    background-color: #fff;
    width: 184px;
    left: -114px;
    bottom: -126px;
    white-space: normal;
    border: 1px solid #000;
    padding: 12px;
    z-index: 1000;
    height: 124px;
  }
  #prompt_close_button,
  #prompt_close_button-mobile {
    min-width: 17px;
    height: 17px;
  }
  .fwa-signin-overlay::before {
    content: '';
    position: absolute;
    top: -4px;
    left: 75%;
    border-width: 1px;
    border-style: solid none none solid;
    width: 5px;
    height: 5px;
    transform: rotate(45deg);
    z-index: 1001;
    background-color: #fff;
  }
  .fwa-signin-text {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;
